import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';

export const mutations: MutationTree<any> = {
  // 获取反馈分页数据信息
  [TYPES.GET_FEEDBACK_LIST.REQUEST](state: IState) {
    state.feedbackList.loading = true;
  },
  [TYPES.GET_FEEDBACK_LIST.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.feedbackList.data = result.Items;
    state.feedbackList.total = result.Total;
    state.feedbackList.loading = false;
  },
  [TYPES.GET_FEEDBACK_LIST.FAILED](state: IState) {
    state.feedbackList.loading = false;
  },

  // 获取反馈详情
  [TYPES.GET_FEEDBACK_DETAIL.REQUEST](state: IState) {
    state.feedbackDetail.loading = true;
  },
  [TYPES.GET_FEEDBACK_DETAIL.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.feedbackDetail.data = result;
    state.feedbackDetail.loading = false;
  },
  [TYPES.GET_FEEDBACK_DETAIL.FAILED](state: IState) {
    state.feedbackDetail.loading = false;
  },
  // 获取反馈详情2
  [TYPES.GET_FEEDBACK_DETAIL_V2.REQUEST](state: IState) {
    state.feedbackDetailV2.loading = true;
  },
  [TYPES.GET_FEEDBACK_DETAIL_V2.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.feedbackDetailV2.data = result;
    state.feedbackDetailV2.loading = false;
  },
  [TYPES.GET_FEEDBACK_DETAIL_V2.FAILED](state: IState) {
    state.feedbackDetailV2.loading = false;
  },
  // 获取客户列表
  [TYPES.CUSTOMER_LIST.REQUEST](state: IState) {
    state.customerList.loading = true;
  },
  [TYPES.CUSTOMER_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.customerList.loading = false;
    state.customerList.data = result.Data.Items || [];
  },
  [TYPES.CUSTOMER_LIST.FAILED](state: IState) {
    state.customerList.loading = false;
  },
  // 获取用户列表
  [TYPES.EMPLOYEE_LIST.REQUEST](state: IState) {
    state.employeeList.loading = true;
  },
  [TYPES.EMPLOYEE_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.employeeList.loading = false;
    state.employeeList.data = result.Data.Items || [];
  },
  [TYPES.EMPLOYEE_LIST.FAILED](state: IState) {
    state.employeeList.loading = false;
  },
  // 获取用户列表
  [TYPES.PM_EMPLOYEE_LIST.REQUEST](state: IState) {
    state.pmEmployeeList.loading = true;
  },
  [TYPES.PM_EMPLOYEE_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.pmEmployeeList.loading = false;
    state.pmEmployeeList.data = result.Data.Items || [];
  },
  [TYPES.PM_EMPLOYEE_LIST.FAILED](state: IState) {
    state.pmEmployeeList.loading = false;
  },
    // 获取产品模块列表
    [TYPES.System_Display_LIST.REQUEST](state: IState) {
      state.ProductValueList.loading = true;
    },
    [TYPES.System_Display_LIST.SUCCESS](state: IState, data) {
      const result = data.res;
      state.ProductValueList.loading = false;
      state.ProductValueList.data = result.Data || [];
    },
    [TYPES.System_Display_LIST.FAILED](state: IState) {
      state.ProductValueList.loading = false;
    },
  // 获取项目列表
  [TYPES.PROJECT_LIST.REQUEST](state: IState) {
    state.projectList.loading = true;
  },
  [TYPES.PROJECT_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.projectList.loading = false;
    state.projectList.data = result.Data.Items || [];
  },
  [TYPES.PROJECT_LIST.FAILED](state: IState) {
    state.projectList.loading = false;
  },
  // 获取子系统列表
  [TYPES.PORDUCT_SBUSYSTEM_LIST.REQUEST](state: IState) {
    state.productSubsystemList.loading = true;
    state.productSubsystemList.data = [];
  },
  [TYPES.PORDUCT_SBUSYSTEM_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.productSubsystemList.loading = false;
    state.productSubsystemList.data = result.Data;
  },
  [TYPES.PORDUCT_SBUSYSTEM_LIST.FAILED](state: IState) {
    state.productSubsystemList.loading = false;
  },
  // 获取模块列表
  [TYPES.PORDUCT_MODULE_LIST.REQUEST](state: IState) {
    state.productModuleList.loading = true;
    state.productModuleList.data = [];
  },
  [TYPES.PORDUCT_MODULE_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.productModuleList.loading = false;
    state.productModuleList.data = result.Data;    
  },
  [TYPES.PORDUCT_MODULE_LIST.FAILED](state: IState) {
    state.productModuleList.loading = false;
  },
  // 获取产品版本列表
  [TYPES.PORDUCT_EDITION_LIST.REQUEST](state: IState) {
    state.productEditionList.loading = true;
    state.productEditionList.data = [];
  },
  [TYPES.PORDUCT_EDITION_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.productEditionList.loading = false;
    state.productEditionList.data = result.Data;
  },
  [TYPES.PORDUCT_EDITION_LIST.FAILED](state: IState) {
    state.productEditionList.loading = false;
  },
  // 获取所有数据(包括禁用数据)

  // 获取子系统列表
  [TYPES.PORDUCT_SBUSYSTEM_ALL_LIST.REQUEST](state: IState) {
    state.allproductSubsystemList.loading = true;
    state.allproductSubsystemList.data = [];
  },
  [TYPES.PORDUCT_SBUSYSTEM_ALL_LIST.SUCCESS](state: IState, data) {

    const result = data.res;
    state.allproductSubsystemList.loading = false;
    state.allproductSubsystemList.data = result.Data;
  },
  [TYPES.PORDUCT_SBUSYSTEM_ALL_LIST.FAILED](state: IState) {
    state.allproductSubsystemList.loading = false;
  },
  // 获取模块列表
  [TYPES.PORDUCT_MODULE_ALL_LIST.REQUEST](state: IState) {
    state.allproductModuleList.loading = true;
    state.allproductModuleList.data = [];
  },
  [TYPES.PORDUCT_MODULE_ALL_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.allproductModuleList.loading = false;
    state.allproductModuleList.data = result.Data;
  },
  [TYPES.PORDUCT_MODULE_ALL_LIST.FAILED](state: IState) {
    state.allproductModuleList.loading = false;
  },
  // 获取产品版本列表
  [TYPES.PORDUCT_EDITION_ALL_LIST.REQUEST](state: IState) {
    state.allproductEditionList.loading = true;
    state.allproductEditionList.data = [];
  },
  [TYPES.PORDUCT_EDITION_ALL_LIST.SUCCESS](state: IState, data) {
    const result = data.res;
    state.allproductEditionList.loading = false;
    state.allproductEditionList.data = result.Data;
  },
  [TYPES.PORDUCT_EDITION_ALL_LIST.FAILED](state: IState) {
    state.allproductEditionList.loading = false;
  },

  // 新增反馈
  [TYPES.COMMIT_PRODUCT_FEEDBACK.REQUEST](state: IState, payload) {
    state.feedbackResult.success = false;
    state.feedbackResult.loading = true;
  },
  [TYPES.COMMIT_PRODUCT_FEEDBACK.SUCCESS](state: IState, data) {
    const result = data.res;
    state.feedbackResult.loading = false;
    state.feedbackResult.message = result.Message;
    state.feedbackResult.success = result.Success;
    state.feedbackResult.request = data.req;
    state.feedbackResult.data = result.Data;    
    Message.success(result.Message);
  },
  [TYPES.COMMIT_PRODUCT_FEEDBACK.FAILED](state: IState) {
    state.feedbackResult.success = false;
    state.feedbackResult.loading = false;
    //Message.error('反馈失败');
  },
  // 更新反馈
  [TYPES.UPDATE_PRODUCT_FEEDBACK.REQUEST](state: IState, payload) {
    state.feedbackResult.success = false;
    state.feedbackResult.loading = true;
  },
  [TYPES.UPDATE_PRODUCT_FEEDBACK.SUCCESS](state: IState, data) {
    const result = data.res;
    state.feedbackResult.loading = false;
    state.feedbackResult.message = result.Message;
    state.feedbackResult.success = result.Success;
    state.feedbackResult.request = data.req;
    Message.success(result.Message);
  },
  [TYPES.UPDATE_PRODUCT_FEEDBACK.FAILED](state: IState) {
    state.feedbackResult.success = false;
    state.feedbackResult.loading = false;
    Message.error('反馈失败');
  },
  // 转单
  [TYPES.TRANSFER_FEEDBACK.REQUEST](state: IState, payload) {
    state.transferResult.success = false;
    state.transferResult.loading = true;
  },
  [TYPES.TRANSFER_FEEDBACK.SUCCESS](state: IState, data) {
    const result = data.res;
    state.transferResult.loading = false;
    state.transferResult.message = result.Message;
    state.transferResult.success = result.Success;
    state.transferResult.request = data.req;
    Message.success(result.Message);
  },
  [TYPES.TRANSFER_FEEDBACK.FAILED](state: IState) {
    state.transferResult.success = false;
    state.transferResult.loading = false;
  },
    // 外部转单
    [TYPES.SAVE_FEEDBACKBYEXTERNAL.REQUEST](state: IState, payload) {
      state.externalAddResult.success = false;
      state.externalAddResult.loading = true;
    },
    [TYPES.SAVE_FEEDBACKBYEXTERNAL.SUCCESS](state: IState, data) {
      const result = data.res;
      state.externalAddResult.loading = false;
      state.externalAddResult.message = result.Message;
      state.externalAddResult.success = result.Success;
      state.externalAddResult.data = result.data;
      Message.success(result.Message);
    },
    [TYPES.SAVE_FEEDBACKBYEXTERNAL.FAILED](state: IState) {
      state.externalAddResult.success = false;
      state.externalAddResult.loading = false;
    },
  // 获取反馈统计
  [TYPES.FEEDBACK_TOTAL.REQUEST](state: IState, payload) {
    state.feedbackTotal.loading = true;
  },
  [TYPES.FEEDBACK_TOTAL.SUCCESS](state: IState, data) {
    const result = data.res;
    state.feedbackTotal.loading = false;
    state.feedbackTotal.data = result && result.Data;
  },
  [TYPES.FEEDBACK_TOTAL.FAILED](state: IState) {
    state.feedbackTotal.loading = false;
  },

  // 获取子系统列表
  [TYPES.GET_SUBSYSTEM.REQUEST](state: IState, payload) {
    state.subsystem.loading = true;
  },
  [TYPES.GET_SUBSYSTEM.SUCCESS](state: IState, data) {
    const result = data.res;
    state.subsystem.loading = false;
    state.subsystem.data = result && result.Data;
  },
  [TYPES.GET_SUBSYSTEM.FAILED](state: IState) {
    state.subsystem.loading = false;
  },

  // 获取经办人配置列表
  [TYPES.GET_ASSIGNEE.REQUEST](state: IState, payload) {
    state.assignee.loading = true;
  },
  [TYPES.GET_ASSIGNEE.SUCCESS](state: IState, data) {
    const result = data.res;
    state.assignee.loading = false;
    state.assignee.success = true;
    state.assignee.data = result && result.Data;
  },
  [TYPES.GET_ASSIGNEE.FAILED](state: IState) {
    state.assignee.loading = false;
    state.assignee.success = false;
  },

  // 获取经办人默认配置列表
  [TYPES.GET_DEFAULT_ASSIGNEE.REQUEST](state: IState, payload) {
    state.defaultAssignee.loading = true;
  },
  [TYPES.GET_DEFAULT_ASSIGNEE.SUCCESS](state: IState, data) {
    const result = data.res;
    state.defaultAssignee.loading = false;
    state.defaultAssignee.success=result.Success;
    state.defaultAssignee.data = result && result.Data;
  },
  [TYPES.GET_DEFAULT_ASSIGNEE.FAILED](state: IState) {    
    state.defaultAssignee.loading = false;
    state.defaultAssignee.success=false;
  },

  // 保存经办人默认配置列表
  [TYPES.ADD_DEFAULT_ASSIGNEE.REQUEST](state: IState, payload) {
    state.addAssignee.loading = true;
  },
  [TYPES.ADD_DEFAULT_ASSIGNEE.SUCCESS](state: IState, data) {
    state.addAssignee.loading = false;
  },
  [TYPES.ADD_DEFAULT_ASSIGNEE.FAILED](state: IState) {
    state.addAssignee.loading = false;
  },

  // 获取经办人设置权限
  [TYPES.GET_ASSIGNEE_PERMISSIONS.REQUEST](state: IState, payload) {
    state.assigneePermission.loading = true;
  },
  [TYPES.GET_ASSIGNEE_PERMISSIONS.SUCCESS](state: IState, data) {
    const result = data.res;
    state.assigneePermission.loading = false;
    state.assigneePermission.success = result && result.Data;
  },
  [TYPES.GET_ASSIGNEE_PERMISSIONS.FAILED](state: IState) {
    state.assigneePermission.loading = false;
  },
  // 撤销反馈信息
  [TYPES.REVOKE_FEEDBACK.REQUEST](state: IState, payload) {
    state.revokeFeedback.success = false;
    state.revokeFeedback.loading = true;
  },
  [TYPES.REVOKE_FEEDBACK.SUCCESS](state: IState, data) {
    const result = data.res;
    state.revokeFeedback.loading = false;
    state.revokeFeedback.success = result && result.Success;
    Message.success(result.Message);
  },
  [TYPES.REVOKE_FEEDBACK.FAILED](state: IState) {
    state.revokeFeedback.loading = false;
  },

  // 满意度评价
  [TYPES.ADD_FeedbackSatisfaction.REQUEST](state: IState, payload) {
    state.feedbackSatisfactionResult.success = false;
    state.feedbackSatisfactionResult.loading = true;
  },
  [TYPES.ADD_FeedbackSatisfaction.SUCCESS](state: IState, data) {
    const result = data.res;
    Message.success(result.Message);
    state.feedbackSatisfactionResult.loading = false;
    state.feedbackSatisfactionResult.data = result && result.Data;
    state.feedbackSatisfactionResult.success = result && result.Success;    
  },
  [TYPES.ADD_FeedbackSatisfaction.FAILED](state: IState) {
    state.feedbackSatisfactionResult.loading = false;
  },

  // 满意度评价
  [TYPES.GET_FeedbackSatisfaction.REQUEST](state: IState, payload) {
    state.feedbackSatisfactionList.success = false;
    state.feedbackSatisfactionList.loading = true;
  },
  [TYPES.GET_FeedbackSatisfaction.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.feedbackSatisfactionList.loading = false;
    state.feedbackSatisfactionList.data = result ;        
    state.feedbackSatisfactionList.success = result && data.res.Success;
    
  },
  [TYPES.GET_FeedbackSatisfaction.FAILED](state: IState) {
    state.feedbackSatisfactionList.loading = false;
    state.feedbackSatisfactionList.success = false;
  },
  
  // 转单信息
  // 是否存在转单信息
  [TYPES.EXIST_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.exsitFeedbacktransfer.loading = true;
  },
  [TYPES.EXIST_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.exsitFeedbacktransfer.loading = false;
    state.exsitFeedbacktransfer.exsit = result ;
  },
  [TYPES.EXIST_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.exsitFeedbacktransfer.loading = false;
  },
  // 保存
  [TYPES.SAVE_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.savefeedbacktransferResult.success = false;
    state.savefeedbacktransferResult.loading = true;
  },
  [TYPES.SAVE_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {
    const result = data.res;
    Message.success(result.Message);
    state.savefeedbacktransferResult.loading = false;    
    state.savefeedbacktransferResult.success = result && result.Success ;
  },
  [TYPES.SAVE_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.savefeedbacktransferResult.loading = false;
  },
  // 获取
  [TYPES.GET_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.feedbacktransferList.success = false;
    state.feedbacktransferList.loading = true;
  },
  [TYPES.GET_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {
    const result = data.res.Data;
    state.feedbacktransferList.loading = false;
    state.feedbacktransferList.data = result ;
    state.feedbacktransferList.success = result && result.Success ;
  },
  [TYPES.GET_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.feedbacktransferList.success = false;
    state.feedbacktransferList.loading = false;
  },
  // 转单接收
  [TYPES.RECEIVE_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.feedbacktransferResult.loading = true;
  },
  [TYPES.RECEIVE_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {
    state.feedbacktransferResult.message = data.res.Message;
    state.feedbacktransferResult.loading = false;
    state.feedbacktransferResult.success = data.res.Success;
  },
  [TYPES.RECEIVE_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.feedbacktransferResult.loading = false;
  },
  // 转单拒收
  [TYPES.REJECTION_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.feedbacktransferResult.loading = true;
  },
  [TYPES.REJECTION_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {
    state.feedbacktransferResult.message = data.res.Message;
    state.feedbacktransferResult.loading = false;
    state.feedbacktransferResult.success = data.res.Success;
  },
  [TYPES.REJECTION_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.feedbacktransferResult.loading = false;
  },
  // 转单催接收
  [TYPES.URGE_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.feedbacktransferResult.loading = true;
  },
  [TYPES.URGE_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {        
    state.feedbacktransferResult.message = data.res.Message;
    state.feedbacktransferResult.loading = false;
    state.feedbacktransferResult.success = data.res.Success;
  },
  [TYPES.URGE_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.feedbacktransferResult.loading = false;
  },
  // 转单撤单
  [TYPES.CANCEL_FEEDBACKSTRANSFER.REQUEST](state: IState, payload) {
    state.feedbacktransferResult.loading = true;
  },
  [TYPES.CANCEL_FEEDBACKSTRANSFER.SUCCESS](state: IState, data) {
    state.feedbacktransferResult.message = data.res.Message;
    state.feedbacktransferResult.loading = false;
    state.feedbacktransferResult.success = data.res.Success;
  },
  [TYPES.CANCEL_FEEDBACKSTRANSFER.FAILED](state: IState) {
    state.feedbacktransferResult.loading = false;
  },
  // 判断用户是否是区域人员
  [TYPES.IS_PRODUCTUSER.REQUEST](state:IState,data ){
    state.isProductUser.loading=true;
    state.isProductUser.success=false;
  },
  [TYPES.IS_PRODUCTUSER.SUCCESS](state:IState,data ){    
    state.isProductUser.loading=false;
    state.isProductUser.success=true;
    state.isProductUser.data=data.res.Data;
  },
  [TYPES.IS_PRODUCTUSER.FAILED](state:IState,data ){
    state.isProductUser.loading=false;
    state.isProductUser.success=false;
  },
    // 判断是否具有提交bug权限
    [TYPES.IS_SUBMITBUGBYUSER.REQUEST](state:IState,data ){
      state.isSubmitBugByUser.loading=true;
      state.isSubmitBugByUser.success=false;
    },
    [TYPES.IS_SUBMITBUGBYUSER.SUCCESS](state:IState,data ){    
      state.isSubmitBugByUser.loading=false;
      state.isSubmitBugByUser.success=true;
      state.isSubmitBugByUser.data=data.res.Data;
    },
    [TYPES.IS_SUBMITBUGBYUSER.FAILED](state:IState,data ){
      state.isSubmitBugByUser.loading=false;
      state.isSubmitBugByUser.success=false;
    },

  // 获取模块默认经办人信息
  [TYPES.GET_DEFAULTASSIGNEEBYMODULE.REQUEST](state:IState,data ){
    state.defaultAssigneeByModule.loading=true;
    state.defaultAssigneeByModule.success=false;
  },
  [TYPES.GET_DEFAULTASSIGNEEBYMODULE.SUCCESS](state:IState,data ){    
    state.defaultAssigneeByModule.loading=false;
    state.defaultAssigneeByModule.success=true;
    state.defaultAssigneeByModule.data=data.res.Data;
  },
  [TYPES.GET_DEFAULTASSIGNEEBYMODULE.FAILED](state:IState,data ){
    state.defaultAssigneeByModule.loading=false;
    state.defaultAssigneeByModule.success=false;
  }    
};
